import React, { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./config/RouterConfig";
import { useDispatch } from "react-redux";
import { initializeApp } from "./features/auth/authSlice";
import PageSpinner from "./components/PageSpinner/PageSpinner";

const App = () => {
  const dispatch = useDispatch();

  // const { isLoading } = useSelector((state) => state.loading);
  // console.log("isLoading", isLoading);

  useEffect(() => {
    dispatch(initializeApp());
  }, [dispatch]);

  return (
    <Suspense fallback={<PageSpinner size="large" fullPage={true} />}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </Suspense>
  );
};

export default App;
